import { indexedStore } from '@/indexedDB/indexedStore.js'

const CACHE_KEY_PREFIX = 'bodybase-training-program'
const CACHE_LIFETIME = 24 * 60 * 60 * 1000

function getCacheKey(userId, programId) {
  return `${CACHE_KEY_PREFIX}-${userId}-${programId}`
}

export const trainingProgramCache = {
  async get(userId, programId) {
    if (!userId || !programId) {
      return null
    }

    try {
      const cache = await indexedStore.slices.base.get(getCacheKey(userId, programId))
      const program = cache?.data

      if (String(program?.id) !== String(programId)) {
        return null
      }

      return program
    } catch (error) {
      console.warn('Failed to restore training program cache', error)
      return null
    }
  },

  async set(userId, programId, program) {
    if (
      !userId
      || !programId
      || String(program?.id) !== String(programId)
    ) {
      return
    }

    try {
      await indexedStore.slices.base.update(getCacheKey(userId, programId), {
        data: program,
        expirationTime: Date.now() + CACHE_LIFETIME,
      })
    } catch (error) {
      console.warn('Failed to save training program cache', error)
    }
  },
}
